export default "__VITE_ASSET__DIBZ0djG__"